const DEAFULT_TRESHOLDS = [1, 5, 10, 20, 40, 80];

cc.Class({
    extends: cc.Component,

    onLoad () {
        this.winThresholds = DEAFULT_TRESHOLDS;
    },

    /**
     * Show prize animation and resolve the promise, when the animation ends
     * @param prize
     * @param betAmount
     * @returns {Promise}
     */
    showPrize (prize, betAmount) {
        cc.warn(`${'Show Prize must be declared in inherited class!' + 'prize:'}${  prize  } bet:${  betAmount}`);

        return Promise.resolve();
    },

    /**
     * Check the level of winning. Compare prize divided by bet value with threshold values and define current
     * win level
     * @param prize
     * @param betAmount
     * @returns {number} winning level
     * @private
     */
    _checkWinningLevel (prize, betAmount) {
        const prizeDivBet = prize / betAmount;
        let level;

        if (prizeDivBet <= this.winThresholds[0]) {
            return 0;
        }

        for (level = this.winThresholds.length - 1; level  >= 0; level--) {    
            if (prizeDivBet >= this.winThresholds[level]) {
                break;
            }
        }

        return level + 1;
    }
});
